'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestFailedWithOperator = undefined;

var _asyncStatuses = require('../constants/asyncStatuses');

var _requestStateUpdate = require('./requestStateUpdate');

/**
 * Set status and operate on data when a request failed
 *
 * @param {Function} operator operator to apply to data
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
 */
var requestFailedWithOperator = exports.requestFailedWithOperator = (0, _requestStateUpdate.requestStateUpdate)(_asyncStatuses.FAILED);